import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  FileSyncOutlined,
  HistoryOutlined,
  IssuesCloseOutlined,
  StopOutlined,
  UserOutlined,
  WarningFilled,
} from '@ant-design/icons';
import Partial from 'assets/svgs/Partial.svg';
import { OrderIntentionStatusEnum } from 'enums/orderIntentionStatus.enum';

export const renderStatusIcon = (status: OrderIntentionStatusEnum) => {
  switch (status) {
    case OrderIntentionStatusEnum.CONFIRMADO:
      return <CheckCircleOutlined style={{ color: '#52C41A' }} />;
    case OrderIntentionStatusEnum.CONFIRMADO_PARCIAL:
      return <img src={Partial} alt="" />;
    case OrderIntentionStatusEnum.CONFIRMADO_ALTERACAO:
      return <IssuesCloseOutlined style={{ color: '#125C4F' }} />;
    case OrderIntentionStatusEnum.PENDENTE:
      return <HistoryOutlined style={{ color: '#FAAD14' }} />;
    case OrderIntentionStatusEnum.AGUARDANDO_GERACAO_PEDIDO:
      return <FileSyncOutlined style={{ color: '#FAAD14' }} />;
    case OrderIntentionStatusEnum.AGUARDANDO_PRODUTOR:
      return <UserOutlined style={{ color: '#FAAD14' }} />;
    case OrderIntentionStatusEnum.RECUSADO:
      return <CloseCircleOutlined style={{ color: '#FA541C' }} />;
    case OrderIntentionStatusEnum.CANCELADO:
      return <StopOutlined style={{ color: '#FF0000' }} />;
    case OrderIntentionStatusEnum.EXPIRADO:
      return <ClockCircleOutlined style={{ color: '#1E1E1E' }} />;
    case OrderIntentionStatusEnum.ERRO:
      return <WarningFilled style={{ color: '#1E1E1E' }} />;
    default:
      return null;
  }
};
